import Cookies from 'js-cookie';

// Cookie configuration
const COOKIE_OPTIONS = {
  expires: 7, // 7 days
  secure: process.env.NODE_ENV === 'production', // Only use secure cookies in production
  sameSite: 'strict', // CSRF protection
  path: '/' // Available throughout the app
};


export const setAuthToken = (token) => {
  Cookies.set('accessToken', token, COOKIE_OPTIONS);
};

export const getAuthToken = () => {
  return Cookies.get('accessToken');
};

export const removeAuthToken = () => {
  Cookies.remove('accessToken');
};

// Admin profile data management
export const setAdminProfileData = (data) => {
  Cookies.set('adminProfileData', JSON.stringify(data), COOKIE_OPTIONS);
};

export const getAdminProfileData = () => {
  const data = Cookies.get('adminProfileData');
  return data ? JSON.parse(data) : null;
};

export const removeAdminProfileData = () => {
  Cookies.remove('adminProfileData');
};

// Admin name management
export const setAdminName = (name) => {
  Cookies.set('adminName', JSON.stringify(name), COOKIE_OPTIONS);
};

export const getAdminName = () => {
  const name = Cookies.get('adminName');
  return name ? JSON.parse(name) : null;
};

export const removeAdminName = () => {
  Cookies.remove('adminName');
};

// Clear all auth-related cookies
export const clearAllAuthCookies = () => {
  removeAuthToken();
  removeAdminProfileData();
  removeAdminName();
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!getAuthToken();
};

// Selected member ID management (for ViewMember page)
export const setSelectedMemberId = (memberId) => {
  Cookies.set('selectedMemberId', memberId, COOKIE_OPTIONS);
};

export const getSelectedMemberId = () => {
  return Cookies.get('selectedMemberId');
};

export const removeSelectedMemberId = () => {
  Cookies.remove('selectedMemberId');
};

// Chart data caching (for dashboard)
export const setChartData = (key, data) => {
  Cookies.set(key, JSON.stringify(data), COOKIE_OPTIONS);
};

export const getChartData = (key) => {
  const data = Cookies.get(key);
  return data ? JSON.parse(data) : null;
};

export const removeChartData = (key) => {
  Cookies.remove(key);
};

// Dashboard data caching
export const setDashboardData = (data) => {
  Cookies.set('dashboardData', JSON.stringify(data), COOKIE_OPTIONS);
};

export const getDashboardData = () => {
  const data = Cookies.get('dashboardData');
  return data ? JSON.parse(data) : null;
};

export const removeDashboardData = () => {
  Cookies.remove('dashboardData');
};

// QR Code caching (for qrCode page)
export const setQRCodeData = (locationId, url, locationName) => {
  Cookies.set(`qrCodeUrl_${locationId}`, url, COOKIE_OPTIONS);
  if (locationName) {
    Cookies.set(`qrCodeLocationName_${locationId}`, locationName, COOKIE_OPTIONS);
  }
};

export const getQRCodeUrl = (locationId) => {
  return Cookies.get(`qrCodeUrl_${locationId}`);
};

export const getQRCodeLocationName = (locationId) => {
  return Cookies.get(`qrCodeLocationName_${locationId}`);
};

export const removeQRCodeData = (locationId) => {
  Cookies.remove(`qrCodeUrl_${locationId}`);
  Cookies.remove(`qrCodeLocationName_${locationId}`);
};

// Generic token management (for different token types like OTP)
export const setToken = (tokenName, token) => {
  Cookies.set(tokenName, token, COOKIE_OPTIONS);
};

export const getToken = (tokenName) => {
  return Cookies.get(tokenName);
};

export const removeToken = (tokenName) => {
  Cookies.remove(tokenName);
};